module.exports = __webpack_public_path__ + "img/music.70ca7b.svg";